// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import color from 'color'
import VueAnalytics from 'vue-analytics'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)

Vue.use(Vuex)
Vue.use(Vuetify, {
  theme: {
    primary: '#5e35b1',
    secondary: '#424242',
    accent: '#9c27b0',
    error: '#B71C1C',
    info: '#0D47A1',
    success: '#2E7D32',
    warning: '#ffb300',
    itemmenu: '#b388ff',
    cert: '#a6a6a6'

  }
})
Vue.config.productionTip = false

Vue.config.devtools = true

const isProduction = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-103937643-2',
  router,
  debug: {
    enabled: !isProduction,
    sendHitTask: isProduction
  }
})

axios.defaults.baseURL = isProduction ? 'https://rapi.mezzow.com/api' : 'http://localhost:8090/api'
axios.defaults.headers.post['Content-Type'] = 'application/json'

const store = new Vuex.Store({
  state: {
    count: 0,
    medicoQuery: '',
    empresaQuery: '',
    unidadeQuery: '',
    usuarioQuery: '',
    menuQuery: '',
    cabecalho: {nomeEmpresa: 'Mezzow QR'},
    userLogin: null,
    menu: []
  },
  mutations: {
    increment (state) {
      state.count++
    },
    changeMedicoQuery (state, params) {
      state.medicoQuery = params.query
    },
    changeEmpresaQuery (state, params) {
      state.empresaQuery = params.query
    },
    changeUnidadeQuery (state, params) {
      state.unidadeQuery = params.query
    },
    changeUsuarioQuery (state, params) {
      state.usuarioQuery = params.query
    },
    changeMenuQuery (state, params) {
      state.menuQuery = params.query
    },
    changeCabecalho (state, params) {
      state.cabecalho = params.cabecalho
      if (state.cabecalho.cor) {
        var metaThemeColor = document.querySelector('meta[name=theme-color]')
        metaThemeColor.setAttribute('content', state.cabecalho.cor)
        this._vm.$vuetify.theme.primary = state.cabecalho.cor
        this._vm.$vuetify.theme.accent = color(state.cabecalho.cor).darken(0.3).rgbNumber()
        this._vm.$vuetify.theme.itemmenu = color(state.cabecalho.cor).lighten(0.3).rgbNumber()
      }
    },
    changeMenu (state, params) {
      var p = `resultado=${params.r}&empresa=${params.e}`
      var self = this
      axios.get(`/menu?${p}`)
        .then(response => {
          state.menu = response.data.list
          if (response.data.cabecalho) {
            self.commit('changeCabecalho', { cabecalho: response.data.cabecalho })
          }
        })
        .catch(e => {
          state.menu = []
        })
    },
    changeUser (state, params) {
      state.userLogin = params.user
      if (params.user) {
        window.localStorage.setItem('token', params.user.access_token)
        axios.defaults.headers.common['X-Auth-Token'] = params.user.access_token
      } else {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user')
        axios.defaults.headers.common['X-Auth-Token'] = null
      }
    }
  }
})

if (window.localStorage.getItem('token')) {
  axios.defaults.headers.common['X-Auth-Token'] = window.localStorage.getItem('token')
  store.commit('changeUser', {
    user: {
      access_token: window.localStorage.getItem('token')
    }
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js